/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BillingAccountMinimalDTO } from '../models/BillingAccountMinimalDTO';
import type { FindBillingAccountQuery } from '../models/FindBillingAccountQuery';
import type { FindExistingBillingAccountQuery } from '../models/FindExistingBillingAccountQuery';
import type { UserDetails } from '../models/UserDetails';
import { request as __request } from '../core/request';

export class AccountsVService {

    /**
     * @param requestBody
     * @returns BillingAccountMinimalDTO OK
     * @throws ApiError
     */
    public static async accountsVFindBillingAccount(
        requestBody?: FindBillingAccountQuery,
    ): Promise<BillingAccountMinimalDTO> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/accounts/find_new_account`,
            body: requestBody,
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
            },
        });
        return result.body;
    }

    /**
     * @param requestBody
     * @returns BillingAccountMinimalDTO OK
     * @throws ApiError
     */
    public static async accountsVFindExistingBillingAccount(
        requestBody?: FindExistingBillingAccountQuery,
    ): Promise<BillingAccountMinimalDTO> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/accounts/me`,
            body: requestBody,
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
            },
        });
        return result.body;
    }

    /**
     * @param billingAccountId
     * @param accountNumber
     * @returns UserDetails OK
     * @throws ApiError
     */
    public static async accountsVAddAccount(
        billingAccountId: string,
        accountNumber?: string,
    ): Promise<UserDetails> {
        const result = await __request({
            method: 'PATCH',
            path: `/api/v2/accounts/${billingAccountId}/add_user`,
            query: {
                'accountNumber': accountNumber,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
            },
        });
        return result.body;
    }

    /**
     * @param billingAccountId
     * @returns UserDetails OK
     * @throws ApiError
     */
    public static async accountsVRemoveAccount(
        billingAccountId: string,
    ): Promise<UserDetails> {
        const result = await __request({
            method: 'PATCH',
            path: `/api/v2/accounts/${billingAccountId}/remove_user`,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
            },
        });
        return result.body;
    }

}